import React, {useEffect} from "react";
import StatementOfAccountAPI from "../api/StatementofAccountsAPI";
import {exportToExcel} from "../utils/functions";
import {capitalizeFirstLetters, dateFormat, formatAccount, timeFormat} from "../features/ValueFormater";
import SalesTransactionsAPI from "../api/salesTransactions";

const ExportButton = ({CurrencyID, dateFrom, dateTo, transactionType, selectedRows}) => {
        const {
            getSOExport,
            exportData,
            setExportData
        } = StatementOfAccountAPI();
        const {
            getSTExport,
            exportTSData,
            setExportTSData
        } = SalesTransactionsAPI();

        useEffect(() => {
            if (exportData) {
                const formattedData = exportData.map((data) => ({
                    Transaction: data.Transaction,
                    Method: data.Method,
                    Beneficiary: capitalizeFirstLetters(data.Beneficiary),
                    Amount: data.Sign === "-" ? "-" + formatAccount(data.Amount, CurrencyID) : formatAccount(data.Amount, CurrencyID),
                    PaymentDate: dateFormat(new Date(data.PaymentDate)),
                    PaymentTime: data.PaymentTime,
                    Status: /^\d/.test(data.Status) ? "Successful" : capitalizeFirstLetters(data.Status)
                }));


                handleDownload(formattedData);
                setExportData(null);
            }

            if (exportTSData) {
                const formattedData = exportTSData.map((data) => ({
                    Transaction: data.Transaction,
                    PaymentDate: dateFormat(new Date(data.PaymentDate)),
                    PaymentTime: timeFormat(new Date(data.PaymentDate)),
                    Type: data.Method,
                    Branch: data.Branch,
                    Till: data.Till,
                    Client: capitalizeFirstLetters(data.Client),
                    Amount: data.Sign === "-" ? "-" + formatAccount(data.Amount, CurrencyID) : formatAccount(data.Amount, CurrencyID),
                    Status: /^\d/.test(data.Status) ? "Successful" : capitalizeFirstLetters(data.Status)
                }));


                handleDownload(formattedData);
                setExportTSData(null);
            }


        }, [exportData, exportTSData])

        const handleExport = () => {
            if (selectedRows.length > 0) {
                if (sessionStorage.getItem("EntityType") === "LEGALENTITY") {
                    const arr = selectedRows.map((row) => ({
                            "Transaction": row.original.Transaction,
                            "Payment Date": row.original.PaymentDate,
                            "Type": row.original.Method,
                            "Amount": formatAccount(row.original.Amount, CurrencyID),
                            "Balance": formatAccount(row.original.Balance, CurrencyID),
                            "Beneficiary": capitalizeFirstLetters(row.original.Beneficiary),
                            "Status": capitalizeFirstLetters(row.original.Status)
                        })
                    )
                    handleDownload(arr);
                }

                if (sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE") {
                    const arr = selectedRows.map((row) => ({
                        Transaction: row.original.Transaction,
                        PaymentDate: dateFormat(new Date(row.original.PaymentDate)),
                        PaymentTime: timeFormat(new Date(row.original.PaymentDate)),
                        Type: row.original.Method,
                        Branch: row.original.Branch,
                        Till: row.original.Till,
                        Client: capitalizeFirstLetters(row.original.Client),
                        Amount: row.original.Sign === "-" ? "-" + formatAccount(row.original.Amount, CurrencyID) : formatAccount(row.original.Amount, CurrencyID),
                        Status: /^\d/.test(row.original.Status) ? "Successful" : capitalizeFirstLetters(row.original.Status)
                    }));
                    handleDownload(arr);
                }
            } else {
                if (sessionStorage.getItem("EntityType") === "LEGALENTITY")
                    getSOExport(CurrencyID, dateFrom, dateTo, transactionType);
                if (sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE")
                    getSTExport(CurrencyID, dateFrom, dateTo, transactionType);
            }
        }

        const handleDownload = (data) => {
            exportToExcel({
                excelData: data,
                filename: `Transactions-${new Date(dateTo)?.getTime() ?? new Date().getTime()}`,
            });
        };

        return (
            <button className="export" onClick={() => {
                handleExport();
            }
            }>Export
            </button>
        );
    }
;

export default ExportButton;
